import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { FieldModel } from '../../../model/myria/app/DynamicForm';
import { ModalController } from 'ionic-angular';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { RouteProvider } from '../../../providers/route/route'

@Component({
  selector: 'search-select-input',
  templateUrl: 'search-select-input.html',
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: SearchSelectInputComponent,
    multi: true
  }]
})
export class SearchSelectInputComponent implements ControlValueAccessor {
  @Input() field: FieldModel;
  @Input() label: string;
  @Input() placeholder: string = "";
  @Input() searchId: string = "";
  @Input() spinnerSelect: boolean;
  @Input() readonly: boolean;
  @Input() elementsPromise: Promise<any>;
  @Input() newDesign: boolean;
  @Input() items;
  @Input() hideSearchbar: boolean = false;
  @Input() modalTitle: string = "";
  @Input() header: string = "";
  @Input() navInfo;
  @Input() flagFromPath: boolean = false;

  @Output() ionChange = new EventEmitter<string>();
  @ViewChild('select') select;
  @ViewChild('selectPicker', { read: ElementRef }) selectPicker;
   /**
   * The error message
  */
   @Input() errorMessage;
   @Input() defaultErrors: boolean = false;
   @Input() refFormControlError;
   @Input() hideError: boolean = false;
   @Input() showOnSubmit: boolean = false;
   @Input() refForm: FormGroup = null;
   @Input() submitAttempts: number = 0;
   @Input() isErrorHidden: boolean = true;
   @Input() isPhone: boolean = false;
   @Input() isCurrency: boolean= false;
   @Input() disabled: boolean = false;

   //#endregion error
  value: string;
  name: string;
  text: string;
  selectItems;
  selectedFlag;
  onChange: any;
  floatContainers;

  constructor(
    private routeProvider: RouteProvider,
    private modalCtrl: ModalController,
    private translate: TranslateService
  ) {}

  ngOnInit() {
    if (!this.placeholder) this.placeholder = ""; // ensure placeholder doesn't contain "undefined"
    if(this.field) {
      this.writeValue(this.field.value)

    }
  }

  ngAfterViewInit() {
    if(this.field)
      this.anyFunc(this.field.value);
  }
  openModal() {
    if(!this.readonly && !this.disabled){
      if(this.navInfo){
        let params = {
          items: this.getItems(),
          modalTitle: this.modalTitle,
          itemSelected: this.getItemSelected()
        };
        this.routeProvider.openActionSheetNew(
          this.routeProvider.pages.ListActionsheetPage,
          params,
          (data) => {
            if (data) {
              this.value = data.value;
              this.text =data.text?data.text:data.Name;
              this.selectItems = [{ text: this.name, value: this.value }];
              this.selectItem(data);
              this.onChange(data.value);
            }
          }
        );

      }
      else {
          let modal = this.modalCtrl.create("SelectPickerPage", {
            items: this.getItems(),
            itemsPromise: this.elementsPromise,
            // itemSelected: this.selectItems[0],
            placeholder: this.placeholder,
            itemSelected: this.getItemSelected(),
            searchId: "searchSelectInputId",
            hideSearchbar: this.hideSearchbar,
            header: this.header
              ? this.header
              : this.translate.instant("global.myRia.jsonContent.DataValidation"),
          });
          modal.present();

          modal.onDidDismiss((data) => {
            if (data) {
              this.value = data.Id ? data.Id : data.value;
              (this.name = data.Name ? data.Name : data.text),
                // this.field.Value = this.value;
                (this.selectItems = [{ text: this.name, value: this.value }]);
              this.onChange(data.Id ? data.Id : data.value);
              this.selectItem(data);
            }
          });
        }
    }

  }

  getItems() {
    if (this.items) return this.items;
    else if (this.field && this.field.Options) return this.field.Options;
    else if (this.field && this.field.options) return this.field.options;
  }

  selectItem(item) {
    if (item.currencyCode) {
      this.value = item.currencyCode;
      this.text = item.currencyCode;
    } else {
      this.value = item.Id ? item.Id : item.value;
      this.text = item.Name ? item.Name : item.text;
      this.anyFunc(this.text);
    }

    this.selectItems = [{ text: this.text, value: this.value }];
    this.ionChange.emit(this.value);
  }

  getItemSelected() {
    let itemSelected = null;
    if (this.selectItems)
        itemSelected = this.selectItems[0];
      else if (!this.selectItems) {
        for (const item of this.items) {
          if (item.currencyCode && item.isDefaultCurrency)
            itemSelected = item;
            itemSelected.isSelected=true
        }
      }

    return itemSelected;
  }

  writeValue(value) {
    let v = null;
    if (value != undefined && value != "") {
      if (this.items) {
        v = this.items.find((o) => o.value == value);
      } else if (this.field && this.field.Options) {
        v = this.field.Options.find((o) => o.Id == value);
      } else if (this.field && this.field.options) {
        v = this.field.options.find((o) => o.value == value);
      }

      if (v) {
        this.value = v.Id ? v.Id : v.value;
        this.name = v.Name ? v.Name : v.text;
      } else {
        this.value = undefined;
        this.name = undefined;
      }
    } else {
      this.name = undefined;
      this.value = undefined;
    }
    this.selectItems = [{ text: this.name, value: this.value }];
    if(this.selectItems[0].text){
      this.anyFunc(this.selectItems[0].text);
    } else {
      this.anyFunc(null);
    }
  }

  registerOnChange(fn) {
    this.onChange = fn;
  }

  registerOnTouched(fn) {}

  setValue(value){
    this.ionChange.emit(value)
  }

  anyFunc(event) {
    if (this.selectPicker && this.selectPicker.nativeElement) {
      const selectElemt = this.selectPicker.nativeElement;
      if (selectElemt && selectElemt.parentNode) {
        if (event) {
          selectElemt.parentNode.classList.add('active');
        } else {
          selectElemt.parentNode.classList.remove('active');
        }
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/components/myria/search-select-input/search-select-input.ts